import React from 'react';
import { Card, CardContent, CardActionArea, Typography, Box, Button } from '@mui/material';
import { Notification } from '../../types/Notification';
import { useNavigate } from 'react-router-dom';
import { humanizeTimestamp } from '../../utility/dateUtils';
import { useToggleNotificationRead } from '../../services/react-query/notifications/useToggleNotificationRead';

interface ITileProps {
  notification: Notification;
}

export default function Tile({ notification }: ITileProps) {
  const navigate = useNavigate();
  const { mutate: toggleRead } = useToggleNotificationRead();

  const handleClick = () => {
    if (!notification.to) return;
    toggleRead(
      { [notification.uuid]: true },
      {
        onSuccess: () => {
          navigate(notification.to);
        },
      }
    );
  };

  const handleToggleRead = (e: React.MouseEvent) => {
    e.stopPropagation();
    toggleRead({ [notification.uuid]: !notification.seen_at });
  };

  const backgroundColor = notification.seen_at ? undefined : 'var(--pale-blue)';
  const borderColor = notification.seen_at ? 'var(--paper)' : 'var(--primary)';
  return (
    <Card sx={{ minWidth: '20vw', borderRadius: 0, backgroundColor, borderBottom: '1px solid var(--border-color)' }}>
      <CardActionArea onClick={handleClick}>
        <CardContent sx={{ p: 2, borderLeft: `4px solid ${borderColor}` }}>
          <Typography variant="body1">{notification.text}</Typography>

          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mt: 1 }}>
            <Typography variant="caption" color="text.secondary">
              {humanizeTimestamp(notification.created_at)}
            </Typography>

            <Button size="small" onClick={handleToggleRead}>
              Mark as {notification.seen_at ? 'Unread' : 'Read'}
            </Button>
          </Box>
        </CardContent>
      </CardActionArea>
    </Card>
  );
}
